import React from 'react';
import { Box, Typography, Button, Alert } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

const AuthDebug = () => {
  const { 
    isAuthenticated, 
    loading, 
    getUsername,
    getOrgId,
    getAppId,
    getLabTypeId 
  } = useAuth();

  const clearStorage = () => {
    localStorage.clear();
    window.location.reload();
  };

  return (
    <Box sx={{ p: 4, maxWidth: 600, mx: 'auto' }}>
      <Typography variant="h4" gutterBottom>
        Auth Debug Panel
      </Typography>
      
      <Alert severity="info" sx={{ mb: 3 }}>
        Check console for detailed debug logs
      </Alert>

      <Box sx={{ mb: 2 }}>
        <Typography variant="h6">Auth State:</Typography>
        <Typography>Loading: {loading ? 'true' : 'false'}</Typography>
        <Typography>Authenticated: {isAuthenticated ? 'true' : 'false'}</Typography>
        <Typography>Current Path: {window.location.pathname}</Typography>
      </Box>

      <Box sx={{ mb: 2 }}>
        <Typography variant="h6">User Data:</Typography>
        <Typography>Username: {getUsername() || 'None'}</Typography>
        <Typography>Org ID: {getOrgId() || 'None'}</Typography>
        <Typography>App ID: {getAppId() || 'None'}</Typography>
        <Typography>Lab Type ID: {getLabTypeId() || 'None'}</Typography>
      </Box>

      <Box sx={{ mb: 2 }}>
        <Typography variant="h6">localStorage:</Typography>
        <Typography>authToken: {localStorage.getItem('authToken') ? 'Present' : 'None'}</Typography>
        <Typography>userData: {localStorage.getItem('userData') ? 'Present' : 'None'}</Typography>
      </Box>

      <Button 
        variant="contained" 
        color="warning" 
        onClick={clearStorage}
        sx={{ mr: 2 }}
      >
        Clear Storage & Reload
      </Button>

      <Button 
        variant="outlined" 
        onClick={() => window.location.href = '/login-simple'}
      >
        Go to Simple Login
      </Button>
    </Box>
  );
};

export default AuthDebug;